<template>
  <div class="store-locator__search">
    <h1>{{ options.title }}</h1>
    <form
      @submit.prevent="processSearch"
      v-if="options.select || options.autocomplete || options.text"
    >
      <v-select
        label="label"
        :reduce="(label) => label.value"
        :options="options.selectOptions"
        v-model="query"
        v-if="options.select"
      ></v-select>
      <div class="form-group" v-if="options.autocomplete || options.text">
        <input
          class="form-control"
          type="text"
          ref="search"
          :placeholder="options.placeholder"
          v-model="query"
        />
        <button class="btn" type="submit"><i class="far fa-search"></i></button>
      </div>
    </form>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: {
    vSelect,
  },
  name: 'cp-search',
  props: {
    options: {
      default: false,
      type: [Boolean, Object],
    },
  },
  data() {
    return {
      autocompleteInput: null,
      // selectOptions: [
      //   { value: 'afrique', label: 'Afrique' },
      //   { value: 'amerique-du-Nord', label: 'Amérique du Nord' },
      //   { value: 'amerique-du-Sud', label: 'Amérique du Sud' },
      //   { value: 'asie', label: 'Asie' },
      //   { value: 'europe', label: 'Europe' },
      // ],
      query: null,
      title: 'Les projets',
    };
  },
  methods: {
    createAutocomplete() {
      if (this.autocompleteInput) {
        window.google.maps.event.clearInstanceListeners(this.autocompleteInput);
      }

      this.autocompleteInput = new window.google.maps.places.Autocomplete(
        this.$refs['search'],
        this.options.autocomplete
      );

      this.autocompleteInput.addListener('place_changed', () => {
        const place = this.autocompleteInput.getPlace();

        if (place.name) {
          if (place.address_components) {
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();

            this.$bus.emit('center-map', lat, lng, 12);
            this.$bus.emit('create-circle', lat, lng);
            this.$bus.emit('create-current-marker', lat, lng);
            this.$bus.emit('display-markers', lat, lng);
          } else {
            const autocompleteService =
              new window.google.maps.places.AutocompleteService();

            autocompleteService.getPlacePredictions(
              {
                ...this.options.autocomplete,
                input: place.name,
                offset: place.name.length,
              },
              (list, status) => {
                if (list && list.length) {
                  this.query = list[0].description;

                  const placesServices =
                    new window.google.maps.places.PlacesService(
                      this.$refs['search']
                    );
                  placesServices.getDetails(
                    { reference: list[0].reference },
                    (serviceResult, serviceStatus) => {
                      if (
                        serviceStatus === window.google.maps.GeocoderStatus.OK
                      ) {
                        this.autocompleteInput.set('place', serviceResult);
                      }
                    }
                  );
                }
              }
            );
          }
        } else {
          // @TODO - reset map position and zoom
          this.$bus.emit('clear-circle');
          this.$bus.emit('clear-current-marker');
          this.$bus.emit('set-displayed-markers', null);
        }
      });
    },

    processSearch(query) {
      if (typeof query !== 'string') {
        if (this.options.autocomplete) {
          return query.preventDefault();
        }

        query = this.query;
      }

      this.$bus.emit('filter', query);
    },
  },
  watch: {
    query(value) {
      if (this.options.live) {
        this.processSearch(value);
      }
    },
  },
  mounted() {
    this.trace('{search.vue} mounted');

    this.$bus.on('api-loaded', () => {
      if (this.options.autocomplete) {
        this.createAutocomplete();
      } else if (this.options.select) {
        this.selectOptions = this.options.select;
      }
    });
  },
};
</script>
